// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BL-10: generic toast stack (bottom-right, above chart chrome). */
.amgdMekcouWDDNgmQP9q {
  position: absolute;
  right: 12px;
  bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1200;
  max-width: min(360px, 80%);
  pointer-events: none;
}

.AveDNdBXpTxdchdhis5q {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--text-primary, #1a1a1a);
  background: var(--toast-bg, #ffffff);
  border: 1px solid var(--border-color, #e8e8e8);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  animation: TjSiWewcjQxXkJZm98zw 0.18s ease-out;
}

.OOPABV8ebij3d9uFwt6g {
  border-left: 3px solid var(--primary-color, #1890ff);
}

._QqKHTSFPIxFAOVTaTst {
  border-left: 3px solid var(--vnsc-color-success, #16a34a);
}

.RGOjzD84zN2XEstXKckR {
  border-left: 3px solid var(--vnsc-color-warning, #d97706);
}

.jtTZHC62s0_Wo4NNbnPB {
  border-left: 3px solid var(--vnsc-color-error, #b91c1c);
}

.JegjiBCDumBO06h_4kwQ {
  flex: 1;
  overflow-wrap: anywhere;
}

.phB3khL99TdiulkfE39J {
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: inherit;
  opacity: 0.6;
  padding: 4px 6px;
  min-width: 24px;
  min-height: 24px;
}

.phB3khL99TdiulkfE39J:hover {
  opacity: 1;
}

@keyframes TjSiWewcjQxXkJZm98zw {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .AveDNdBXpTxdchdhis5q {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/widget/components/Toast.module.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,oCAAoC;EACpC,8CAA8C;EAC9C,0CAA0C;EAC1C,8CAAiC;AACnC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* BL-10: generic toast stack (bottom-right, above chart chrome). */\r\n.stack {\r\n  position: absolute;\r\n  right: 12px;\r\n  bottom: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  z-index: 1200;\r\n  max-width: min(360px, 80%);\r\n  pointer-events: none;\r\n}\r\n\r\n.toast {\r\n  pointer-events: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  color: var(--text-primary, #1a1a1a);\r\n  background: var(--toast-bg, #ffffff);\r\n  border: 1px solid var(--border-color, #e8e8e8);\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);\r\n  animation: toastIn 0.18s ease-out;\r\n}\r\n\r\n.info {\r\n  border-left: 3px solid var(--primary-color, #1890ff);\r\n}\r\n\r\n.success {\r\n  border-left: 3px solid var(--vnsc-color-success, #16a34a);\r\n}\r\n\r\n.warn {\r\n  border-left: 3px solid var(--vnsc-color-warning, #d97706);\r\n}\r\n\r\n.error {\r\n  border-left: 3px solid var(--vnsc-color-error, #b91c1c);\r\n}\r\n\r\n.message {\r\n  flex: 1;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.dismiss {\r\n  border: 0;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  line-height: 1;\r\n  color: inherit;\r\n  opacity: 0.6;\r\n  padding: 4px 6px;\r\n  min-width: 24px;\r\n  min-height: 24px;\r\n}\r\n\r\n.dismiss:hover {\r\n  opacity: 1;\r\n}\r\n\r\n@keyframes toastIn {\r\n  from { opacity: 0; transform: translateY(8px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .toast {\r\n    animation: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stack": `amgdMekcouWDDNgmQP9q`,
	"toast": `AveDNdBXpTxdchdhis5q`,
	"toastIn": `TjSiWewcjQxXkJZm98zw`,
	"info": `OOPABV8ebij3d9uFwt6g`,
	"success": `_QqKHTSFPIxFAOVTaTst`,
	"warn": `RGOjzD84zN2XEstXKckR`,
	"error": `jtTZHC62s0_Wo4NNbnPB`,
	"message": `JegjiBCDumBO06h_4kwQ`,
	"dismiss": `phB3khL99TdiulkfE39J`
};
export default ___CSS_LOADER_EXPORT___;
